/* unplugin-vue-components disabled */import { render } from "./fire.vue?vue&type=template&id=9a5003ae"
import script from "./fire.vue?vue&type=script&lang=js"
export * from "./fire.vue?vue&type=script&lang=js"

import "./fire.vue?vue&type=style&index=0&id=9a5003ae&lang=less"

import exportComponent from "E:\\vuewebpage3\\ydqbyg-dz2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__